import React from 'react';
import { motion } from 'framer-motion';

const items = [
  '✦ Transformando Vidas',
  '✦ Fé com Propósito',
  '✦ Liderança Cristã',
  '✦ Educação Financeira',
  '✦ Projeto Divas',
  '✦ Psicoterapia Cristã',
  '✦ Projeto Águias',
  '✦ Princípios Bíblicos',
  '✦ Conferências & Palestras',
  '✦ Prosperidade com propósito',
];

const MarqueeStrip = ({ reverse = false, speed = 35 }) => {
  // Duplicate items for seamless loop
  const all = [...items, ...items];
  const duration = all.length * speed / 10;

  return (
    <div
      style={{
        overflow: 'hidden',
        borderTop: '1px solid var(--border-light)',
        borderBottom: '1px solid var(--border-light)',
        background: 'var(--bg-section)',
        padding: '0.9rem 0',
        position: 'relative',
        zIndex: 1,
      }}
    >
      {/* Fade edges */}
      <div style={{
        position: 'absolute', top: 0, left: 0, bottom: 0, width: 80,
        background: 'linear-gradient(to right, var(--bg-section), transparent)',
        zIndex: 2, pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', top: 0, right: 0, bottom: 0, width: 80,
        background: 'linear-gradient(to left, var(--bg-section), transparent)',
        zIndex: 2, pointerEvents: 'none',
      }} />

      <motion.div
        style={{
          display: 'flex',
          gap: '3rem',
          width: 'max-content',
          willChange: 'transform',
        }}
        animate={{ x: reverse ? ['0%', '50%'] : ['-50%', '0%'] }}
        transition={{
          duration,
          ease: 'linear',
          repeat: Infinity,
        }}
        whileHover={{ animationPlayState: 'paused' }}
      >
        {all.map((text, i) => (
          <span
            key={i}
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '0.75rem',
              fontWeight: 500,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              color: i % 3 === 0 ? 'var(--accent-gold-400)' : 'var(--text-muted)',
              whiteSpace: 'nowrap',
              userSelect: 'none',
            }}
          >
            {text}
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default MarqueeStrip;
